export default __webpack_public_path__ + "static/media/kid-7.cb26312e.JPG";